import { DriverStop } from './outbox';

/** Šta se vraća u magacin na kraju ture. */
export interface Ostatak {
  komada: number;
  stanica: number;
  /** Po jedan red po stanici: „Odžaci: Veš mašina, Frižider". */
  spisak: string[];
}

/**
 * Da li pri odlasku sa stanice treba pitati šta je sa robom.
 *
 * Pita se samo kad nešto STVARNO ostaje i kad razlog još nije upisan. Ako je
 * vozač već označio izuzetak („kupac nije kod kuće"), odgovor postoji i drugo
 * pitanje bi bilo gnjavljenje.
 *
 * ZAŠTO SE UOPŠTE PITA
 *   Do 11.09.2026. je odlazak sa stanice prolazio nemo, i sa 0/3 štiklirano.
 *   Izmereno na živim podacima: od 318 napuštenih stanica, 35 je ostavilo
 *   neštikliranu robu, a 28 od njih BEZ IJEDNOG RAZLOGA. Jedini čovek koji je
 *   znao zašto roba nije predata bio je vozač — a niko ga nije pitao dok je
 *   stajao tamo.
 */
export function trebaPitatiZaOstatak(stop: DriverStop): boolean {
  if (stop.removedAt) {
    return false;
  }

  if (stop.exceptionReason) {
    return false;
  }

  return stop.items.some((i) => !i.isDelivered);
}

/**
 * Roba koja se vraća u magacin: sve nepredato, sa svih živih stanica.
 *
 * Skinuta stanica se ne broji. Njena roba jeste u vozilu, ali je o njoj
 * operater već odlučio kad je stanicu skinuo — ponovo je nuditi vozaču na
 * kraju dana znači tražiti odluku koja je već doneta.
 */
export function ostatakTure(stops: DriverStop[]): Ostatak {
  const spisak: string[] = [];
  let komada = 0;
  let stanica = 0;

  for (const stop of stops) {
    if (stop.removedAt) {
      continue;
    }

    const ostale = stop.items.filter((i) => !i.isDelivered);

    if (ostale.length === 0) {
      continue;
    }

    stanica += 1;
    komada += ostale.length;
    spisak.push(`${stop.name}: ${ostale.map((i) => i.articleName).join(', ')}`);
  }

  return { komada, stanica, spisak };
}
